import { Component } from '@angular/core';
import { Alignment } from '@dekra-ds/angular';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent {
  protected readonly Alignment = Alignment;
}
